import { Source } from '../../services/ApiService';

import { IInvoiceDetailsRequest } from './IInvoiceDetailsRequest';
import { InvoiceSettlement } from './InvoiceSettlement';
import { ContentType } from './ContentType';

export class Invoice implements IInvoiceDetailsRequest {
  public amount: number;
  public issuedDate: Date;
  public dueDate: Date;
  public assignedName: string;
  public invoiceNumber: string;
  public referenceNumber: string;
  public source: Source;
  public contentType: ContentType;
  public unsettledAmount: number;
  public settlements: InvoiceSettlement[];
  public customerId: number;
  public subscriber?: string;
  public restricted: boolean;
  public invoiceServiceDetailsAccess: boolean;
  public settledByCorrectionTransaction: boolean;

  public iconName: string;

  public get paidAmount(): number {
    return this.amount - this.unsettledAmount;
  }
}
